(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('ValidationResult', [
        'ObjUtil',
        ValidationResultFactory,
    ]);

    function ValidationResultFactory(
        ObjUtil
    ) {

        ValidationResult.mapFromApi = mapFromApi;
        return ValidationResult;

        function ValidationResult(hasWarning, message) {
            ObjUtil.defineReadonlyProps(this, {
                hasWarning: !!hasWarning,
                message: message || '',
            });
        }

        function mapFromApi(resultObj) {
            if(!resultObj) {
                return new ValidationResult();
            }

            return new ValidationResult(resultObj.HasWarning, resultObj.Message);
        }
    }

})(window.angular);
